/**
 * Small CRM API request body schemas used by workers/api handlers.
 */

import { z } from 'zod';

import { CreateFeatureRequestSchema } from './feature-request.schemas';

export const SelectSkuSchema = z.object({
  skuId: z.string().min(1),
});

export const ConfirmAccountDeleteSchema = z.object({
  code: z.string().min(1),
});

export const UpdateConsentSchema = z.object({
  analyticsConsent: z.boolean(),
  consentVersion: z.string().min(1),
});

/** Alias for CreateFeatureRequestSchema (title/description + optional attachments). */
export const CreateFeatureRequestBodySchema = CreateFeatureRequestSchema;

export const VoteFeatureRequestSchema = z.object({
  voteType: z.enum(['up', 'down']),
});

/** Permissive dashboard layout payload (widgets + version metadata). */
export const DashboardLayoutSchema = z
  .object({
    widgets: z.array(z.record(z.unknown())).optional(),
    version: z.number().optional(),
    isCustomized: z.boolean().optional(),
    enabledWidgetIds: z.array(z.string()).optional(),
    lastSyncedAt: z.string().optional(),
    updatedAt: z.string().optional(),
  })
  .passthrough();

export const AttachmentUploadSchema = z.object({
  fileName: z.string().min(1),
  mimeType: z.string().optional(),
  contentType: z.string().optional(),
  fileType: z.string().optional(),
});

export const AttachmentConfirmSchema = z.object({
  attachmentId: z.string().min(1),
  blobPath: z.string().min(1),
  fileName: z.string().min(1),
  mimeType: z.string().min(1),
  size: z.number().nonnegative(),
  fileType: z.enum(['document', 'image', 'video']),
});
